export { default } from './ItemDetailsConnector';
